var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wl-dialog-form",
    {
      ref: "wl-dialog-form",
      attrs: {
        "form-options": { "label-width": "110px" },
        url: "/trace/stack-route/getFlowItemData",
        open: _vm.show,
        width: "1000px",
        btns: _vm.btns,
        grid: _vm.grid,
        title: _vm.title,
        model: _vm.form,
        rules: _vm.rules,
        loading: _vm.loading,
        disabled: _vm.disabled,
      },
      on: {
        "update:open": function ($event) {
          _vm.show = $event
        },
        getDatasSuccess: _vm.getDatasSuccess,
        getDatasError: _vm.getDatasError,
        onOk: _vm.onOk,
        openDialog: _vm.openDialog,
        closeDialog: _vm.closeDialog,
      },
      scopedSlots: _vm._u([
        {
          key: "after",
          fn: function () {
            return [
              _c(
                "el-row",
                {
                  staticClass: "tableCell",
                  staticStyle: { padding: "2px 0 0" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "tableEntryForm",
                      attrs: { disabled: true, model: _vm.tableEntryForm },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "entryTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.tableEntryForm.tableData,
                            border: "",
                            height: "300px",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "序号",
                              type: "index",
                              width: _vm.$store.state.settings.serialWidth,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "header-align": "center",
                              label: "序列号",
                              prop: "processCode",
                              width:
                                _vm.$store.state.settings.datetimetypewidth,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "header-align": "center",
                              label: "采集人",
                              prop: "processCode",
                              width:
                                _vm.$store.state.settings.materielcodewidth,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "header-align": "center",
                              label: "采集时间",
                              prop: "processCode",
                              width:
                                _vm.$store.state.settings.datetimetypewidth,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "header-align": "center",
                              label: "栈码",
                              prop: "processCode",
                              width:
                                _vm.$store.state.settings.datetimetypewidth,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              fixed: "right",
                              label: "操作",
                              width: "120",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          staticStyle: { height: "60px" },
          attrs: { slot: "tabs-top", label: "基本信息" },
          slot: "tabs-top",
        },
        [
          _c("wl-form-control", {
            attrs: {
              form: _vm.form,
              grid: _vm.grid,
              "form-items": _vm.formItems.basic,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }